import { useEffect, useState } from 'react';
import styles from './scrollToTop.module.css';
import { FaChevronUp } from "react-icons/fa";


export default function ScrollToTop() {

  const [isVisible, setIsVisible] = useState(false);

  let debounceTimeout = null;
  const debounce = (callback, delay) => {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => {
      callback();
    }, delay);
  };

  const handleScroll = () => {
    debounce(() => {
      if (window.scrollY > 700) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    }, 200);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {isVisible &&
        <div className={styles.container} onClick={scrollToTop}>
          <FaChevronUp className='text-light' />
        </div>
      }
    </>
  )
}
